import React, { useEffect } from 'react';
import styles from './style.module.scss';
import { Spin } from 'antd';
import { useParams } from 'react-router-dom';

const OldQrRedirect = () => {
  const { id } = useParams();
  useEffect(() => {
    let apiUrl = process.env.REACT_APP_API_URL;
    apiUrl = apiUrl.replace('/api/v1', '');
    window.location.href = `${apiUrl}/companies/${id}`;
  }, [id]);
  return (
    <div className={styles.oldQrRedirectContainer}>
      <Spin size='large' />
    </div>
  );
};

export default OldQrRedirect;
